import React from 'react';
import { connect } from 'react-redux';
import { IAppState } from 'types/app';

import FeedMessageControls from './FeedMessageControls';
import MessageList from './MessageList';

export function FeedMessagesComponent(props: OwnProps & ReturnType<typeof mapStateToProps>) {
  const {
    messages,
    title,
    type,
  } = props;
  return (
    <div className="message" style={{ marginBottom: '10px' }}>
      <h1
        className="heading heading--1 messages__heading"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {title}
        {type !== 'feedMessages' && (
          <FeedMessageControls />
        )}
      </h1>
      <MessageList
        messages={messages}
        type={type}
      />
    </div>
  );
}

type OwnProps = {
  title: string,
  type: 'feedMessages' | 'interactions',
};

const mapStateToProps = ({ messages }: IAppState, { type }: OwnProps) => ({ messages: messages[type] });

export default connect(mapStateToProps)(FeedMessagesComponent);